export function extractYouTubeVideoId(url: string): string | null {
  const trimmed = url.trim();
  if (!trimmed) return null;

  if (/^https?:\/\/(www\.)?youtube\.com\/?$/.test(trimmed)) {
    return null;
  }

  if (trimmed.includes("youtube.com/embed/")) {
    const match = trimmed.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
    return match?.[1] ?? null;
  }

  const shortMatch = trimmed.match(
    /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
  );
  if (shortMatch?.[1]) return shortMatch[1];

  const watchMatch = trimmed.match(
    /(?:youtube\.com\/(?:watch\?v=|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  );
  if (watchMatch?.[1]) return watchMatch[1];

  return null;
}

/** Accepts a bare 11-char ID or any supported YouTube URL. */
export function normalizeYouTubeVideoId(
  input: string | null | undefined,
): string | null {
  if (!input?.trim()) return null;

  const trimmed = input.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) return trimmed;

  return extractYouTubeVideoId(trimmed);
}

export function getYouTubeEmbedUrl(
  videoIdOrUrl: string | null | undefined,
): string | null {
  const videoId = normalizeYouTubeVideoId(videoIdOrUrl);
  if (!videoId) return null;

  return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
}

export function getYouTubeWatchUrl(
  videoIdOrUrl: string | null | undefined,
): string | null {
  const videoId = normalizeYouTubeVideoId(videoIdOrUrl);
  if (!videoId) return null;

  return `https://www.youtube.com/watch?v=${videoId}`;
}

export function resolveThemeYoutubeEmbedUrl(
  variants: { light?: string | null; dark?: string | null },
  theme: "light" | "dark",
): string | null {
  const preferred =
    theme === "dark" ? variants.dark || variants.light : variants.light || variants.dark;

  return getYouTubeEmbedUrl(preferred);
}

export function resolveHelpArticleVideoEmbedUrl(
  translation: {
    youtubeVideoId?: string | null;
    youtubeVideoIdDark?: string | null;
  } | null
  | undefined,
  theme: "light" | "dark",
): string | null {
  if (!translation) return null;

  return resolveThemeYoutubeEmbedUrl(
    {
      light: translation.youtubeVideoId,
      dark: translation.youtubeVideoIdDark,
    },
    theme,
  );
}
